import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { CommonMediaQueries, Schema, SectionIds } from '@shared/models';
import { MediaScreenService } from '@shared/services';

import { SortSchemasPipe } from '../../pipes';

interface Benefit {
  title: string;
  description: string;
  rows: Schema[][];
}

@Component({
  selector: 'rp-home-benefits',
  standalone: true,
  templateUrl: './benefits.component.html',
  styleUrl: './benefits.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgClass, AsyncPipe, SortSchemasPipe],
})
export class BenefitsComponent {
  readonly isTablet$: Observable<boolean>;

  readonly benefitsId: SectionIds = SectionIds.Benefits;
  readonly benefits: Benefit[] = [
    {
      title: 'content.forAffiliates',
      description: 'benefits.empoweringWebmasters',
      rows: [
        [
          {
            icon: 'individual-terms',
            title: ['forAffiliates.individualTerms'],
            desktopIndex: 0,
            mobileIndex: 0,
          },
          {
            icon: 'pwa-apps',
            title: ['forAffiliates.apps1', 'forAffiliates.apps2'],
            desktopIndex: 1,
            mobileIndex: 1,
          },
        ],
        [
          {
            icon: 'exclusive-offers',
            title: ['general.exclusive', 'forAffiliates.offers'],
            desktopIndex: 0,
            mobileIndex: 0,
          },
          {
            icon: 'unique-payment',
            title: ['forAffiliates.uniquePaymentSolution'],
            desktopIndex: 1,
            mobileIndex: 2,
          },
          {
            icon: 'infrastructure',
            title: ['forAffiliates.infrastructure', 'forAffiliates.forWork'],
            desktopIndex: 2,
            mobileIndex: 1,
          },
        ],
      ],
    },
    {
      title: 'content.forAdvertisers',
      description: 'benefits.equippingAdvertisers',
      rows: [
        [
          {
            icon: 'virtual',
            title: ['forAdvertisers.assistance', 'forAdvertisers.analysis'],
            desktopIndex: 0,
            mobileIndex: 0,
          },
          {
            icon: 'fraud',
            title: ['forAdvertisers.powerfulSystem', 'forAdvertisers.system'],
            desktopIndex: 1,
            mobileIndex: 1,
          },
        ],
        [
          {
            icon: 'traffic',
            title: ['forAdvertisers.highQualityTraffic'],
            desktopIndex: 0,
            mobileIndex: 0,
          },
          {
            icon: 'media-buying',
            title: ['forAdvertisers.ownMediaBuying'],
            desktopIndex: 1,
            mobileIndex: 1,
          },
          {
            icon: 'direct-integration',
            title: ['forAdvertisers.directIntegration'],
            desktopIndex: 2,
            mobileIndex: 2,
          },
        ],
      ],
    },
  ];

  private readonly _mediaScreenService = inject(MediaScreenService);

  constructor() {
    this.isTablet$ = this._mediaScreenService.mediaMatcher(CommonMediaQueries.MD);
  }
}
